import { LegalPage } from "./legal-page.tsx";

export function CookiesPage() {
  return <LegalPage slug="cookies" />;
}
